import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';

import { platformType } from '../../../../../core/utils/platform-type';

import {
  Column,
  Container,
  ColumnName,
  ColumnValue,
  ErrorMessage,
  Grid,
  Row,
  UserInterviewsMessage,
  Image,
} from './styles';

const nameWidth = 5;
const valueWidth = 8;

const EmploymentInfo = (props) => {
  const { user, compact, showUserInterviewsRecruited } = props;
  const { profile } = user;

  // make sure currentPosition have same fields for signup survey and linkedin.
  // signup survey is the top priority
  const [fields] = useState(() => {
    const {
      currentPosition,
      linkedinFields,
    } = profile;

    if (!_.isEmpty(currentPosition)) {
      return currentPosition;
    }
    if (linkedinFields && linkedinFields.currentPosition) {
      return linkedinFields;
    }

    return null;
  });

  const { jobInfo = '' } = profile || {};

  const [jobDisplayLabel, jobDisplayName] = useMemo(() => {
    const jobLabel = jobInfo === 'job_title' ? 'Job Title' : 'Job Role';

    const jobName = jobInfo === 'job_title'
      ? _.get(fields, 'title')
      : _.join(_.map(_.get(profile, 'jobCategories'), 'name'), ', ');

    return [jobLabel, jobName];
  }, [jobInfo, fields, profile]);

  const filteredEmployment = {
    [jobDisplayLabel]: jobDisplayName || null,
    Industry: _.get(fields, 'company.industry') || null,
    'Company Size': _.get(fields, 'company.size') || null,
    Seniority: _.get(fields, 'seniority') || null,
  };

  if (_.isEmpty(profile.currentPosition)) {
    return (
      <Container>
        <ErrorMessage>
          Current position is empty.
        </ErrorMessage>
      </Container>
    );
  }

  return (
    <Container compact={compact}>
      <Grid columns={2}>
        {_.map(filteredEmployment, (value, name) => (
          <Row key={name}>
            <Column weight={500} width={nameWidth}>
              <ColumnName>
                {name}
              </ColumnName>
            </Column>
            <Column width={valueWidth}>
              <ColumnValue>
                {value}
              </ColumnValue>
            </Column>
          </Row>
        ))}
      </Grid>

      {platformType === 'company' && showUserInterviewsRecruited && (
        <UserInterviewsMessage>
          Participant recruited by
          <Image src="/images/user-interviews-logo.svg" alt="User Interviews" />
        </UserInterviewsMessage>
      )}
    </Container>
  );
};

EmploymentInfo.propTypes = {
  user: PropTypes.shape({
    profile: PropTypes.shape({
      currentPosition: PropTypes.shape({}),
      linkedinFields: PropTypes.string,
    }),
  }).isRequired,
  compact: PropTypes.bool,
  showUserInterviewsRecruited: PropTypes.bool,
};

EmploymentInfo.defaultProps = {
  compact: true,
  showUserInterviewsRecruited: false,
};
export default EmploymentInfo;
